import { IconBrandDatabricks, IconServerBolt } from '@tabler/icons-react';

const deployments = {
    id: 'deployments',
    title: 'DEPLOYMENTS',
    icon: IconBrandDatabricks,
    type: 'group',
    children: [
        {
            id: 'deployments-list',
            title: 'DEPLOYMENTS',
            type: 'item',
            url: '/deployments',
            icon: IconBrandDatabricks,
            breadcrumbs: false
        },
        {
            id: 'deployment-request',
            title: 'DEPLOYMENT REQUEST',
            type: 'item',
            url: '/deployment-request',
            icon: IconServerBolt,
            breadcrumbs: false
        }
    ]
};

export default deployments;
